import { useContext } from 'react';
import usePeriods from '../../state/hooks/usePeriods';
import { getAreaSelectionPeriodFromEvent } from '../../../CustomReport/custom-report.util';
import MetricsInspectionContext from '../../state/context';
import { onAreaPointHover } from '../../state/actions';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const useChartEvents = () => {
  const { selectPeriod } = usePeriods();
  const {
    dispatch,
    state: { widget }
  } = useContext(MetricsInspectionContext);

  const onAreaSelect = e => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS_INSPECTION,
      click_type: TRACKING.CLICK.AREA_SELECT,
      widget_name: widget?.name,
      element: `${widget?.agg} area`
    });
    e.preventDefault();
    const period = getAreaSelectionPeriodFromEvent(e);
    if (!period) return;
    selectPeriod(period);
  };

  const onPointHover = e => {
    e?.preventDefault();
    const point = e?.target;
    dispatch(onAreaPointHover(point));
  };

  const onPointClick = (e, ...rest) => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.METRICS_INSPECTION,
      click_type: TRACKING.CLICK.SINGLE_CLICK,
      widget_name: widget?.name,
      element: `${widget?.agg} point click`
    });
    e.preventDefault();
    const period = e?.point?.category;
    if (!period) return;
    selectPeriod(period);
  };

  return {
    onAreaSelect,
    onPointHover,
    onPointClick
  };
};

export default useChartEvents;
